<template>

  <div class="app">



    <Header ref="header" ></Header>

    <div class="conversion">
      <div style="background:rgb(246, 251, 253) none repeat scroll 0% 0%">
        <div class="features">
        <div class="title" @click="isshow=false">短网址和二维码专业服务商</div>
        <div class="service">修改原链接，永久有效，网址检测，批量生成</div>
        <div class="input-box" style="position: relative;">

          <div style="text-align: left;position: absolute;top:-30px;left:172px;width:850px;cursor: pointer;">
            <span  @click="$router.push('/tabs/webPage')" style="display: inline-block;text-align: center;font-size: 14px;color: #008DF2 !important;border-radius: 5px;padding:2px 20px;"><span style="background:#008DF2;color:#fff;padding:2px 5px;border-radius: 3px; ">网址</span> | <strong>文本 | 图片 | 视频 | 文件</strong>   没有链接？使用生成单页功能可直接由内容生成！点击这里</span>
            <span @click="$router.push('/tabs/renling')" style="margin-left: 120px;">认领游客链接？</span>
          </div>

          <input id="url" type="text" v-model="url" />
          <button class="blue-btn" @click="zh">转换</button>

          <router-link to="/tabs/batchConversion"  class="green-btn">批量转换</router-link>

        </div>



        <div class="tips" id="tips" style="padding-top: 50px;width:900px;margin:0px auto;">
          <router-link to="/apidoc" ><i class="iconfont  icon-dwzchart-bar"> API接口文档</i></router-link>
          <router-link to="/statisticsDemo" ><i class="iconfont  icon-dwzchart-bar"> 数据统计demo体验</i></router-link>
          <router-link to="/tabs/shortUrlList" ><i class="iconfont  icon-dwzsuyuanmaguanli" style="color:red;"> 支持修改原链接</i></router-link>
          <router-link to="/home_hm" ><i class="iconfont  icon-dwzlanjie" style="color:green;"> 二维码活码</i></router-link>
          <router-link to="/tabs/flowRecharge" ><i class="iconfont  icon-dwzchart-bar"> 购买访问包（送VIP）</i></router-link>
          <router-link to="/tabs/shortUrlList" ><i class="iconfont  icon-dwzsuyuanmaguanli"> 提示浏览器打开</i></router-link>
          <router-link to="/home_wx" ><i class="iconfont  icon-dwzchart-bar"> 微信安全检测/api</i></router-link>
          <router-link to="/tabs/buyDomain" ><i class="iconfont  icon-dwzchart-bar"> 专属短域名</i></router-link>

        </div>

        <div class="prompt" style="margin-top:50px;">

          <router-link v-if="isGuest" to="/login"><font color="red">提示：免费短链接可能会有广告，仅供临时使用，如需稳定服务，请登录付费</font></router-link>
          <router-link v-else to="/tabs/flowRecharge"><font color="red">限时活动购买任意访问包送VIP，拥有高级功能和数据统计，无广告安全保障！</font></router-link>
        </div>
      </div>
      </div>

      <div class="box gray-back">
        <div class="management gray-back">
          <div class="title">多场景解决方案</div>
          <div class="subtitle">推广通道，ttdwz.cc帮助您快速决策，选出优质渠道，优化成本和转化率</div>
          <div class="icon-box">
            <div><i class="iconfont  icon-dwzlianjie1 icon-blue"></i><br><br>多链接支持</div>
            <div><i class="iconfont  icon-dwzapp icon-blue"></i><br><br>APP推广</div>
            <div><i class="iconfont icondaikuan- icon-blue"></i><br><br>产品推广</div>
            <div><i class="iconfont iconduanxin- icon-blue"></i><br><br>短信营销</div>

          </div>
          <div class="remark">
            <div>支持多条链接，可设置多条链接等比跳转，方便您展示多个推广内容不同比例的分配</div>
            <div>规避关键词、域名屏蔽手段，适合做付费推广链接，方便跟踪点击量、地域分布等用户统计，做渠道推广决策。</div>
            <div>每找到一家，就要换一家，自身链接总被屏蔽不是群发无法抵达，就是红标和屏蔽。天天短网址安全可靠。</div>
            <div>使用短网址，精简内容，方便阅读，“一对一”的传递信息，强制性阅读，时效性强，客户转化率也会比较高。</div>

          </div>
        </div>
      </div>

      <div class="box">
        <div class="management">
          <div class="title">管理短网址，提升运营效率</div>
          <div class="subtitle">集管理、替换、数据统计、高级功能、报表分析于一体，为运营决策保驾护航</div>
          <div class="icon-box">
            <div><i class="iconfont iconlianjie-"></i><br><br>管理短网址</div>
            <div><i class="iconfont icondianpu"></i><br><br>数据统计</div>
            <div><i class="iconfont iconkongzhiqi"></i><br><br>高级功能</div>
            <div><i class="iconfont iconqiehuan"></i><br><br>提升留存</div>
          </div>
          <div class="remark">
            <div>支持单个转换，批量转换，历史转换记录，提供二维码下载，一次生成，安全稳定，永久有效。</div>
            <div>免费统计pv、uv、ip，pc识别统计，移动设备识别统计，用户地区识别统计，专业的统计报表满足多维度的运营需求。</div>
            <div>可以替换已生成短网址的原链接，为短网址设置访问密码，针对不同地区、不同设备，一个链接有多个推广落地页。</div>
            <div>了解用户行为路径，优化核心转化路径，提高转化，把访客变成客户，把流量变成注册和购买。</div>
          </div>
        </div>
      </div>

      <div class="box gray-back">
        <div class="message_intro gray-back">
          <div class="title">天天短网址使用帮助</div>
          <div class="subtitle">帮助您快速掌握天天短网址使用流程</div>
          <div class="introduce" style="text-align: left">
            <router-link to="/problem#problem1">1.什么是短网址</router-link>
            <router-link to="/problem#problem2">2.免费用户和VIP用户的区别</router-link>
            <router-link to="/problem#problem3">3.天天短网址二维码的功能说明</router-link>
            <router-link to="/problem#problem4">4.高级功能之访问密码设置说明</router-link>
            <router-link to="/problem#problem5">5.高级功能之地区定位功能说明</router-link>
            <router-link to="/problem#problem6">6.高级功能之设备定位功能说明</router-link>
            <router-link to="/problem#problem7">7.高级功能之VIP专业报表功能说明</router-link>
            <router-link to="/problem#problem8">8.高级功能之替换原网址功能说明</router-link>
          </div>
        </div>
      </div>

      <div class="box">
        <div class="control">
          <div class="text">
            <div class="title">
              <span>控制台</span>
              <span>专业 · 简单 · 易用</span>
            </div>
            <div class="list-title">操作简单，便捷高效</div>
            <div class="list-content">复制黏贴，一键生成，也可批量生成短网址，更便捷的操作流程，提高您的转换效率</div>
            <div class="list-title">统一管理，便于维护</div>
            <div class="list-content">建议您注册登录，在我们的控制台统一管理您的短网址，系统会帮您记录已生成的链接，对应每条链接的数据统计、二维码下载，便于长期维护和使用。生成的链接，安全稳定，永久有效</div>
          </div>
          <div class="img">
            <img src="../assets/images/index/1-01.png" alt="控制台">
          </div>
        </div>
      </div>

      <div class="box gray-back">
        <div class="control gray-back">
          <div class="img" style="padding-top: 25px;">
            <img src="../assets/images/index/1-02.png" alt="高级功能">
          </div>
          <div class="text">
            <div class="title pl-10" style="margin-top: 25px;">
              <span>高级功能</span>
              <span></span>
            </div>
            <div class="list-title pl-10">一个链接多个推广落地页</div>
            <div class="list-content pl-10">使用场景更广泛，您可能需要在不同的推广地区，不同的用户设备之间，推广不同的落地页面。使用高级功能，做出组合型智能策略，将不同用户导向不同的最终页面，满足您多维度的推广需求。</div>
            <div class="list-title pl-10">更换原链接，设置访问密码</div>
            <div class="list-content pl-10">对于您已经生成的短网址，如果原链接有所变化，目前在推的短网址不便于重新生成，您可以进行原链接的替换，短网址不变，原链接替换为新的。例如，已大量印刷出推广二维码的用户，原链接替换功能，再合适不过了。</div>
          </div>
        </div>
      </div>

      <div class="box">
        <div class="controls">
          <div class="text">
            <div class="title" style="margin-top: 40px;">
              <span>多维度的数据统计</span>
              <span></span>
            </div>
            <div class="list-title">一条短网址，一个统计报表</div>
            <div class="list-content">全方位数据统计，支持访问次数统计pv、uv、ip，浏览趋势，访问明细统计，访问地区、浏览器、用户客户端设备统计、访问记录、详细ip记录明细</div>
            <div class="list-title">精准数据，实时统计</div>
            <div class="list-content">全天候监控统计，数据实时刷新，每日数据的ip、pv、uv各项数据指标，支持历史数据跟踪对比，有效验证假设和推广方案的可行性和有效性，为运营推广提供最有效的保障。</div>
            <div class="list-title">提升留存，挖掘客户价值</div>
            <div class="list-content">了解用户行为路径，优化核心转化路径，提高转化，把访客变成客户，把流量变成注册和购买。 精准定位产品增长点，提高用户使用核心功能的时长，培养用户使用习惯，让用户持续地使用你的产品。</div>
          </div>
          <div class="img" style="padding-top: 60px;">
            <img src="../assets/images/index/1-03.png" alt="数据统计">
          </div>
        </div>
      </div>

      <div class="box" style="background:#F5F5F5;">
        <div class="jubao">
          <div class="title">违规违法短网址举报入口<a name="jubao"></a></div>
          <div class="subtitle">本平台禁止违法违规内容生成短链接</div>
          <div class="jubao_main">
            <div style="width:600px;line-height: 200%;">
              免责声明<br>
              1. 短网址由用户生成，所跳转的内容与本站无关 <br>
              2. 本站严禁包括但不限于病毒、钓鱼、色情、诈骗、VPN等违法违规内容的网站生成短网址,如有发现立刻封停！ <br>
              3. 使用即遵守本声明，本站概不承担任何法律责任。<br>

            </div>
            <div>
              <div><input type="text" v-model="jubao_url" placeholder="输入违法链接"></input> </div>
              <div> <textarea  v-model="jubao_content" placeholder="举报内容，如色情，赌博，诈骗 等"></textarea> </div>
                <div> <button class="blue-btn" @click="jb">举报</button> </div>
            </div>
          </div>
        </div>
      </div>

      <div class="boxs ">
        <div class="contact ">
          <div class="title">联系我们</div>
          <div class="subtitle">欢迎商务洽谈与合作</div>
          <div class="icon-box">
            <div>
              <div class="icons"><i class="iconfont iconlianxiren2"></i></div>
              <div class="text">联系人</div>
              <div class="value">李经理</div>
            </div>
<!--            <div>-->
<!--              <div class="icons"><i class="iconfont iconweixin3"></i></div>-->
<!--              <div class="text">商务微信</div>-->
<!--              <div class="value">fade_fei</div>-->
<!--            </div>-->
            <div>
              <div class="icons"><i class="iconfont iconQQ"></i></div>
              <div class="text">客服QQ</div>
              <div class="value">3683390325</div>
            </div>
<!--            <div>-->
<!--              <div class="icons"><i class="iconfont iconyouxiang"></i></div>-->
<!--              <div class="text">客服微信</div>-->
<!--              <div class="value">111</div>-->
<!--            </div>-->
          </div>
        </div>
      </div>

      <div class="box gray-back">


      </div>
    </div>
    <Foot ref="foot" ></Foot>

  </div>

</template>

<script>




  import Header from "./header";
  import Foot from "./foot";

  export default {
    name: "home",
    components: { Header:Header,Foot:Foot},
    data() {

      return {
        url:"",
        isVip: false,
        isGuest: true,
        isshow:false,
        user_info: {},
        jubao_url:'',
        jubao_content:'',

      }
    },
    mounted() {
      const token = this.$storeLocal.get('token');
      const user_info = this.$storeLocal.get('userInfo');
      const times = Date.parse(new Date())/1000;

      if (token !== null && token !== '' && token !== undefined) {
        if (user_info.expire_date > times){
          this.isVip = true;
        }
        this.isGuest = false;
        this.user_info = user_info;
      }

      var url222=window.location.href;
      if(url222.match(/xcyqz/)){
        $('.foot_1').show();
      }else if(url222.match(/hrbxyykj/)){
        $('.foot_2').show();
      }else if(url222.match(/lizhi888/)){
        $('.foot_3').show();
      }else if(url222.match(/jinmingxuan5/)){
        $('.foot_4').show();
      }else if(url222.match(/runchang/)){
        $('.foot_5').show();
      }else if(url222.match(/zgzzlzkjapp/)){
        $('.foot_6').show();
      }else{
        $('.foot_0').show();
      }

      if(url222.match(/ttdwz|45t|192\.168/)){
        $('.downbox22').show();
      }

      const codeTime = this.$cookies.get('codeTime');
      const captchaStr = this.$cookies.get('captchaStr');

      if (token !== undefined && token !== null && token !== ''){
        // this.$router.push('/tabs/index');
      }
      if (captchaStr !== undefined && captchaStr !== null && captchaStr !== ''){
        this.captchaStr = captchaStr;
      }
      if (codeTime > 0){
        console.log(codeTime);
        this.time = codeTime;
        this.timer();
      }
    },
    methods: {
      async zh() {
        if(this.isGuest){
          // this.isshow=!this.isshow;
          // this.$refs.header.isshow=true;
          // return;
        }
        const url = this.url;
        if (url === ""){
          this.$message.error('链接不能为空！');
          return;
        }
        const isUrl = this.$common.isUrl(url);
        if (!isUrl){
          this.$message.error('网址格式不正确，需要以http://或https://开头！');
          return;
        }
        const sg = this.$common.urlSign(url);
        const getData = {
          url: url,
          sg: sg,
        };
        const {ret,data} = await this.$api.index.zh(getData);
        console.log(data);
        if (ret === 1000){
          await this.$router.push('/conversion/' + data.id);
        }
      },
      async jb() {
        const jubao_url = this.jubao_url;
        if (jubao_url === ""){
          this.$message.error('举报链接不能为空！');
          return;
        }
        const jubao_content = this.jubao_content;
        const getData = {
          jubao_url: jubao_url,
          jubao_content: jubao_content,
        };
        const {ret,data} = await this.$api.index.jubao(getData);
        console.log(data);
        if (ret === 1000){
          this.$message.success('举报成功，我们将尽快合适！');
        }
      },




    },

    beforeRouteEnter (to, from, next) {
      next();
    },
  }
</script>

<style>
.app{background-color:#ffffff}
.gold{color:#FFD700}
a{text-decoration:none;cursor:pointer;color:#ffffff}
button{cursor:pointer}
.blue-btn{background-color:#008DF2}
.green-btn{background-color:#07CC00}
.gray-back{background-color:#F5F5F5!important}
.pl-10{padding-left:10%}
.conversion{width:100%}
.conversion .features{width:1200px;height:490px;text-align:center;margin:0 auto;padding-top:110px}
.conversion .features .title{width:100%;height:40px;font-size:40px;color:#008DF2;margin-bottom:30px}
.conversion .features .service{width:100%;height:22px;font-size:22px;color:#999999;margin-bottom:80px}
.conversion .features .input-box{width:100%;height:45px}
.conversion .features .tips{width:100%;height:50px;padding-top:10px}
.conversion .features .tips a{margin-right:20px;color:#008DF2;font-weight:bold;border:1px #008DF2 solid;padding:4px 8px;display:inline-block;border-radius:2px;margin-bottom:10px}
.conversion .features .tips a:hover{background:#008DF2;color:#fff !important}
.conversion .features .tips .error{height:35px;display:inline-block;background-color:#FFF2F2;border:1px #FFE5E6 solid;color:#FE0000;text-align:left;line-height:35px;padding:0 20px}
.conversion .features .input-box input{width:570px;height:41px;font-size:30px;border:1px #BFBFBF solid;border-right:0;vertical-align:bottom}
.conversion .features .input-box button{width:120px;height:45px;outline:none;margin:0;padding:0;border:1px solid transparent;vertical-align:bottom;color:#ffffff;font-size:16px}
.conversion .features .input-box a{width:120px;height:45px;vertical-align:bottom;color:#ffffff;font-size:16px;display:inline-block;line-height:45px}
.conversion .features .prompt{width:100%;height:16px;color:#999999}
.conversion .box{width:100%;background-color:#ffffff}
.conversion .box .management{width:1200px;height:500px;padding-top:100px;text-align:center;margin:0 auto}
.conversion .box .management .title{width:100%;height:40px;font-size:40px;color:#333333;margin-bottom:30px}
.conversion .box .management .subtitle{width:100%;height:20px;font-size:20px;color:#999999;margin-bottom:80px}
.conversion .box .management .icon-box{width:100%;height:130px;font-size:0}
.conversion .box .management .icon-box div{width:25%;height:100%;display:inline-block;vertical-align:top;color:#333333;font-size:18px}
.conversion .box .management .icon-box div i{font-size:60px}
.conversion .box .management .remark{width:100%;height:80px;font-size:0}
.conversion .box .management .remark div{width:23%;height:100%;display:inline-block;vertical-align:top;font-size:14px;color:#666666;padding:0 1%;text-align:left}
.conversion .box .control{width:1200px;height:600px;margin:0 auto;font-size:0}
.conversion .box .control .text{width:46%;height:510px;display:inline-block;vertical-align:top;padding-top:90px}
.conversion .box .control .text .title{width:90%;height:45px;margin-top:45px;margin-bottom:50px;font-size:0}
.conversion .box .control .text .title span:nth-child(1){height:100%;display:inline-block;font-size:40px;color:#333333;text-align:left;line-height:45px;vertical-align:top;padding-right:25px}
.conversion .box .control .text .title span:nth-child(2){height:100%;display:inline-block;font-size:22px;color:#666666;text-align:left;line-height:45px;vertical-align:top}
.conversion .box .control .text .list-title{width:90%;height:25px;font-size:22px;color:#333333;margin-bottom:20px}
.conversion .box .control .text .list-content{width:90%;font-size:16px;color:#999999;margin-bottom:30px;line-height:26px}
.conversion .box .control .img{width:54%;height:530px;display:inline-block;vertical-align:top;padding-top:70px}
.conversion .box .controls{width:1200px;height:600px;margin:0 auto;font-size:0}
.conversion .box .controls .text{width:46%;height:100%;display:inline-block;vertical-align:top}
.conversion .box .controls .text .title{width:90%;height:45px;margin-top:50px;margin-bottom:50px;font-size:0}
.conversion .box .controls .text .title span:nth-child(1){height:100%;display:inline-block;font-size:40px;color:#333333;text-align:left;line-height:45px;vertical-align:top;padding-right:25px}
.conversion .box .controls .text .title span:nth-child(2){height:100%;display:inline-block;font-size:22px;color:#666666;text-align:left;line-height:45px;vertical-align:top}
.conversion .box .controls .text .list-title{width:90%;height:25px;font-size:22px;color:#333333;margin-bottom:20px}
.conversion .box .controls .text .list-content{width:90%;font-size:16px;color:#999999;margin-bottom:30px;line-height:26px}
.conversion .box .controls .img{width:54%;height:100%;display:inline-block;vertical-align:top;text-align:center}
.conversion .boxs{width:100%;height:500px;background-image:url("../assets/images/index/contact-bg.png")}
.conversion .boxs .contact{width:1200px;height:450px;padding-top:50px;margin:0 auto;color:#ffffff;text-align:center;background-image:url("../assets/images/index/contact-bgs.png")}
.conversion .boxs .contact .title{width:100%;height:35px;font-size:32px;margin-bottom:20px}
.conversion .boxs .contact .subtitle{width:100%;height:25px;font-size:20px;margin-bottom:65px}
.conversion .boxs .contact .icon-box{width:100%;height:170px;font-size:0;margin-bottom:60px}
.conversion .boxs .contact .icon-box div{width:240px;height:100%;display:inline-block;vertical-align:top}
.conversion .boxs .contact .icon-box div .icons{width:90px;height:90px;border-radius:50px;border:1px #ffffff solid}
.conversion .boxs .contact .icon-box div .icons i{line-height:90px;font-size:40px}
.conversion .boxs .contact .icon-box div .text{width:240px;height:35px;font-size:14px;padding-top:20px}
.conversion .boxs .contact .icon-box div .value{width:240px;height:20px;font-size:14px}
.conversion .boxs .contact .explain{width:100%;height:25px;font-size:20px}
.conversion .box .copyright{width:1200px;height:140px;padding-top:40px;text-align:center;margin:0 auto;color:#666666}
.conversion .box .copyright div{width:100%;height:14px;font-size:14px;margin-bottom:25px}
.conversion .box .copyright div span{display:inline-block;padding:0 10px}
.conversion .box .copyright div span a{color:#666666}
.conversion .box .list-box{width:1200px;margin:0 auto;margin-top:30px}
.conversion .box .list-box .description{width:100%;height:190px;line-height:35px}
.conversion .box .list-box .link-list{width:100%;text-align:center;position:relative}
.conversion .box .list-box .link-list a{color:#00aaee}
.conversion .box .list-box .link-list .limit{display:block;width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.conversion .box .list-box .link-list table{border-bottom:1px solid #e6e6e6;width:978px;table-layout:fixed}
.conversion .box .list-box .link-list tr th{border-top:1px solid #e6e6e6;padding:0 5px;color:#333;vertical-align:middle;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;background-color:#f5f5f5;font-weight:normal;line-height:34px}
.conversion .box .list-box .link-list tr td{border-top:1px solid #e6e6e6;padding:10px 5px;color:#666;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;vertical-align:middle}
.conversion .box .list-box .link-list tr:hover td{background-color:#f2faff}
.conversion .box .list-box .link-list .wdh1{width:200px}
.conversion .box .list-box .link-list .wdh2{width:500px}
.conversion .box .list-box .link-list .wdh3{width:300px}
.conversion .box .list-box .link-list .wdh4{width:200px}
.conversion .box .list-box .link-list .st1{color:#4FA246}
.conversion .box .list-box .link-list .st2{color:#3E78D6}
.conversion .box .list-box .link-list .st3{color:#FF180A}
.conversion .box .list-box .link-list .refresh{width:100px;height:40px;position:absolute;top:-50px;right:0}
.conversion .box .list-box .link-list .refresh button{width:100px;height:40px;display:block;font-size:16px;color:#fff;border:none;cursor:pointer;line-height:40px;text-align:center;background-color:#008df2;border-radius:5px}
.conversion .box .list-box .link-list .refresh button:hover{opacity:.8;filter:alpha(opacity=80)}
.conversion .box .message_intro{width:1200px;height:500px;padding-top:50px;text-align:center;margin:0 auto}
.conversion .box .message_intro .title{width:100%;height:40px;font-size:40px;color:#333333;margin-bottom:30px}
.conversion .box .message_intro .subtitle{width:100%;height:20px;font-size:20px;color:#999999;margin-bottom:80px}
.conversion .box .message_intro .introduce{width:100%;height:70px;font-size:0}
.conversion .box .message_intro .introduce a{width:30%;height:100%;display:inline-block;vertical-align:top;font-size:20px;color:#666666;padding:0 1%;text-align:left}
.conversion .box .management{width:1200px;height:500px;padding-top:100px;text-align:center;margin:0 auto}
.contactusdiyou .hoverbtn{width:30px;height:129px;padding-top:20px;cursor:pointer;position:absolute;top:50%;margin-top:-66px;left:-30px;font-size:14px;color:#fff;background:#008df2;-webkit-border-radius:3px 0px 0px 3px;-moz-border-radius:3px 0px 0px 3px;-o-border-radius:3px 0px 0px 3px;border-radius:3px 0px 0px 3px;-moz-box-shadow:-4px 4px 4px -4px #000;-webkit-box-shadow:-4px 4px 4px -4px #000;box-shadow:-4px 4px 4px -4px #000}
.contactusdiyou .hoverbtn span{width:30px;height:19px;line-height:19px;text-align:center;overflow:hidden;float:left}
.contactusdiyou .hoverbtn .hoverimg{width:13px;height:9px;margin:10px 0 0 10px;float:left;display:inline;background-repeat:no-repeat}
.hoverimg2{background:url(../assets/images/index/hoverbtnbg1.gif) no-repeat}
.contactusdiyou .conter{width:186px;height:560px;margin-left:22px;position:absolute;top:55%;*margin-top:-140px;margin-top:-280px}
.contactusdiyou .conter .con1{border-bottom:1px solid #6a6a6a;padding-bottom:22px}
.contactusdiyou .conter .con1 dl dt{width:31px;height:31px;float:left;position:relative;top:32px}
.contactusdiyou dl .f1{width:142px;height:36px;line-height:36px;float:right;font-size:14px;_font-size:14px;*font-size:15px;color:#fff;vertical-align:top;font-weight:bold}
.contactusdiyou dl .f2{width:142px;float:right;font-size:12px;color:#fff;height:30px;line-height:30px}
.kefuQQ a{background:url(../assets/images/index/button-custom-qq.gif) no-repeat;width:70px;height:20px;display:inline-block;vertical-align:middle}
.kefuQQ a:hover{background:url(../assets/images/index/button-custom-qq-h.gif) no-repeat}
.contactusdiyou .conter .con1 dl dd .ph_num{font:18px 'Microsoft yahei';*font-size:16px;_font-size:16px;color:#fff;height:25px}
.contactusdiyou .qqcall{padding:22px 0;border-bottom:1px solid #6a6a6a}
.contactusdiyou .qqcall dl dt{width:31px;height:31px;float:left;position:relative;top:32px}
.contactusdiyou .weixincall{float:right;padding:22px 0;border-bottom:1px solid #6a6a6a}
.contactusdiyou .weixincall dl dt{width:31px;height:31px;float:left;position:relative;top:32px}
.contactusdiyou .weixincall .f3{float:right;width:73px;height:auto;margin-right:69px;display:inline}
.contactusdiyou .weixincall .f3 img{width:150px;height:auto}
.contactusdiyou .dytimer{float:right;width:160px;height:40px;padding:16px 0 15px 0;margin:20px 0 0 0}
.contactusdiyou .dytimer span{display:block;height:20px;line-height:20px;font-size:14px;color:#fff}
.userProtocol{}
.userProtocol .bg-color{background-color:white;width:1200px;height:60px;text-align:center}
.userProtocol .bg-color a{color:black;font-size:20px;line-height:60px}
.userProtocol .box-center{width:1200px;margin:0 auto}
.userProtocol .box{width:100%}
.userProtocol .word_area{padding:24px;margin-bottom:30px;background-color:#F5F5F5;color:#555;overflow:hidden}
.userProtocol .box .copyright{width:1200px;height:140px;padding-top:40px;text-align:center;margin:0 auto;color:#666666}
.userProtocol .box .copyright div{width:100%;height:14px;font-size:14px;margin-bottom:25px}
.userProtocol .box .copyright div span a{color:#666666}
.userProtocol h3,h1{font-size:16px;margin-bottom:25px}
.userProtocol h1{font-size:25px;text-align:center;margin-bottom:25px}
.userProtocol ol{margin-bottom:20px;text-indent:2em;line-height:25px}
.line-bottom{border-bottom:1px solid #FFFFFF}
.user-console .u-rig{width:1200px;min-height:780px;margin:0 auto}
.user-console h2.title{border-left:4px solid #008bff;height:20px;line-height:20px;padding-left:5px;margin:10px 0 20px 0;font-size:22px;font-weight:500}
.icon-blue{color:#008df2}
.qrCode{width:200px;height:200px;margin:0 auto;border:1px solid #d7dae2;position:relative}
.header-right .item a{color:#666666}
.vcode{width:200px;margin-right:20px}
.sendBtn{width:140px}
.login_btn{width:100%}
.box-card{width:400px;margin:100px auto}
.countdown{width:100%;height:30px;font-size:14px;text-align:center}
.code-div{width:100%;height:100%}
.image-slot{width:200px;height:200px;text-align:center;line-height:200px;background-color:rgba(0,0,0,0.1);position:absolute;top:0;left:0}
.image-slot i{color:#808080;font-size:50px}
.agreement{color:#409EFF;font-weight:500;cursor:pointer}
.copyright{width:100%;color:#666666;text-align:center}
.captcha-img{display:inline-block;width:110px;height:36px;padding:2px 0;margin-left:10px;vertical-align:top}


.jubao{width:1200px;margin:0px auto;background:#F5F5F5;}
.jubao .title{font-size:32px;padding:20px;text-align: center;}
.jubao .subtitle{text-align: center;font-size:20px;color:#999;}
.jubao .jubao_main input{border:1px solid #ccc;height:40px;width:400px;}
.jubao .jubao_main{ text-align: left;padding:20px;margin-bottom:50px;display: flex; justify-content: space-between}
.jubao textarea{width:400px;height:120px;border:1px solid #ccc;margin-top:15px;}
.jubao button{height:43px;color:#fff;padding: 0px 20px;margin-top:15px;}

</style>
